module.exports = __webpack_public_path__ + "img/stream_xandercagez1.2594665.png";